import request from "@/utils/request";
import {exportFile} from "@/api/common";
import qs from 'qs'

const PREFIX_URL = process.env.NODE_ENV === 'development' ? '' : ''

// 商品分析
export function getListingPerformedAnalysis(params) {
    return request.post('/operation/listingAnalyze/show/page', params)
        .then(res => res.data)
}

// 商品表现、店铺表现--获取Session、CVR、PV、BuyBox折线图
export function trafficTrendInfo(params) {
    return request.post('/operation/traffic/trafficTrendInfo', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}


export function getListingStatisticsAnalysis(params) {
  return request.post('/operation/listingAnalyze/statistics/page', params);
}

// 店铺分析
export function getMarketPerformedAnalysis(params) {
    return request.post('/operation/storeAnalyze/show/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

// 销售表现趋势分析
export function getListingTrendAnalyze(params) {
    return request.post('/operation/listingAnalyze/show/trendAnalyze', params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

//销售表现趋势合计
export function getListingTrendTotal(params) {
    return request.post('/operation/listingAnalyze/show/trendAnalyzeTotal', params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}
// 销售表现趋势导出
export function exportTrendAnalyze(params) {
    exportFile('/operation/listingAnalyze/export/trendAnalyze', params);
}

export function exportMarketPerformedAnalysis(params) {
    exportFile('/operation/storeAnalyze/show/export', params);
}

export function getMarketStatisticsAnalysis(params) {
    return request.post('/operation/storeAnalyze/statistics/page', params);
}

export function exportMarketStatisticsAnalysis(params) {
    exportFile('/operation/storeAnalyze/statistics/export', params);
}

// 产品分析

export function getProductPerformedAnalysis(params) {
    return request.post('/operation/skuAnalyze/show/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function exportProductPerformedAnalysis(params) {
    exportFile('/operation/skuAnalyze/show/export', params);
}

export function getChildProductPerformedAnalysis(params) {
    return request.post('/operation/skuAnalyze/show/detailPage', params)
        .then((res) => {
        return Promise.resolve(res.data);
    })
}

export function getProductStatisticsAnalysis(params) {
    return request.post('/operation/skuAnalyze/statistics/page', params)
        .then((res) => {
            return Promise.resolve(res);
        })
}

export function exportProductStatisticsAnalysis(params) {
    exportFile('/operation/skuAnalyze/statistics/export', params);
}

export function getChildProductStatisticsAnalysis(params) {
    return request.post('/operation/skuAnalyze/statistics/detailPage', params)
        .then((res) => {
        return Promise.resolve(res);
    })
}

// FBA补货
export function getFbaRestockPage(params) {
    return request.post('/operation/fbaRestock/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportFbaRestock(params) {
    exportFile('/operation/fbaRestock/export', params);
}

// 月度仓储费
export function getStorageFeePage(params) {
    return request.post('/operation/storageFee/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportStorageFee(params) {
    exportFile('/operation/storageFee/export', params);
}

// 长期仓储费
export function getLongStorageFeePage(params) {
    return request.post('/operation/longStorageFee/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportLongStorageFee(params) {
    exportFile('/operation/longStorageFee/export', params);
}

// 赔偿报表
export function getReimbursementPage(params) {
    return request.post('/operation/reimbursement/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportReimbursement(params) {
    exportFile('/operation/reimbursement/export', params);
}

// 盘库
export function getInventoryAdjustmentsPage(params) {
    return request.post('/operation/inventoryAdjustments/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportInventoryAdjustments(params) {
    exportFile('/operation/inventoryAdjustments/export', params);
}

// 商品表现导入业务报告
export const importBusinessReport = params => {
    return request.get(`${PREFIX_URL}/operation/listingAnalyze/importListingBusinessReports`, { params }).then(res => res)
}

/**
 * 基本信息
 * asin-361
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getListingInfo = params => {
    return request.get(`${PREFIX_URL}/operation/asin361/basic/listingInfo`, { params }).then(res => res.data)
}

/**
 * 获取asin列表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getAsinList = params => {
    return request.get(`${PREFIX_URL}/operation/asin361/asins`, { params }).then(res => res.data)
}

/**
 * 获取综合分析概览数据
 * asin-361
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getComprehensiveAnalysisReview = params => {
    return request.get(`${PREFIX_URL}/operation/asin361/comprehensive/overviewAndPie`, { params }).then(res => res.data)
}

/**
 * 获取综合分析折线图
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getComprehensiveAnalysisLine = params => {
    return request.get(`${PREFIX_URL}/operation/asin361/comprehensive/lineChart`, { params }).then(res => {
        let resMap = res.data
        resMap.statisticsData || (resMap.statisticsData = [])
        resMap.statisticsData = resMap.statisticsData.map((item) => {
            for (const key in item) {
                if (item[key] === null) {
                    item[key] = 0
                }
            }
            return item
        })
        resMap.thenData || (resMap.thenData = [])
        resMap.thenData = resMap.thenData.map((item) => {
            for (const key in item) {
                if (item[key] === null) {
                    item[key] = 0
                }
            }
            return item
        })
        return Promise.resolve(resMap);
    })
}

/**
 * 综合分析导出报表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getComprehensiveAnalysisExport = params => {
    return request.get(`${PREFIX_URL}/operation/asin361/comprehensive/lineChart`, { params }).then(res => res.data)
}

/**
 * 获取销售排名
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getSellerRankLine = params => {
    return request.get(`${PREFIX_URL}/operation/asin361/sale/sellerRankChart`, { params }).then(res => res.data)
}

/**
 * 获取订单站点分布与订单累计分布
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getOrderDistributed = params => {
    return request.get(`${PREFIX_URL}/operation/asin361/sale/orderDistributed`, { params }).then(res => res.data)
}

/**
 * 订单站点区域分布
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getOrderAreaDistributed = params => {
    return request.post(`${PREFIX_URL}/operation/storeOperation/sale/orderAreaDistributed`, params).then(res => res.data)
}

/**
 * 获取订单站点分布与订单累计分布
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getHoursDistributed = params => {
    return request.get(`${PREFIX_URL}/operation/asin361/sale/hoursDistributed`, { params }).then(res => res.data)
}

/**
 * 获取广告分析-气泡图
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getAdBubbleAnalysis = params => {
    return request.get(`${PREFIX_URL}/ads/statistics/analysis/asin/chart/bubble`, { params }).then(res => res.data)
}

/**
 * 获取广告分析-表格
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postAdTableAnalysis = params => {
    return request.post(`${PREFIX_URL}/ads/statistics/analysis/asin/page`, params).then(res => res.data)
}

/**
 * 获取广告分析-指标趋势折线图
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getAdLineAnalysis = params => {
    return request.get(`${PREFIX_URL}/ads/statistics/analysis/asin/chart/line`, { params }).then(res => res.data)
}

/**
 * 获取广告活动下拉框（分页）
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postCampaginSelect = params => {
    return request.get(`${PREFIX_URL}/ads/statistics/analysis/asin/campagin`, { params }).then(res => res.data)
}

/**
 * 获取review统计数据
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReviewAnalysis = params => {
    return request.post(`${PREFIX_URL}/crm/asin361/reviewAnalyse`, params).then(res => res.data)
}

/**
 * review列表
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReviewList = params => {
    return request.post(`${PREFIX_URL}/crm/asin361/reviews`, params).then(res => res.data)
}

/**
 * review详情
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReviewDetail = id => {
    return request.post(`${PREFIX_URL}/crm/asin361/${id}/detail`).then(res => res.data)
}

/**
 * review日志
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReviewLog = id => {
    return request.post(`${PREFIX_URL}/crm/asin361/${id}/logs`).then(res => res.data)
}

/**
 * 评星分布
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postCommentAnalysis = params => {
    return request.post(`${PREFIX_URL}/crm/asin361/reviewChart`, params).then(res => res.data)
}

export const getRemoteMapJson = (url, params) => {
    return request({
        url,
        method: 'GET',
        params
    }).then(res => res)
}

/**
 * 评星分析
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postCommentBarAnalysis = params => {
    return request.post(`${PREFIX_URL}/crm/asin361/reviewCountAnalyse`, params).then(res => res.data)
}

/**
 * 获取星级数据
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postLevelAnalysis = params => {
    return request.post(`${PREFIX_URL}/crm/asin361/starChart`, params).then(res => res.data)
}

/**
 * 获取退货原因数据
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReturnReasonAnalysis = params => {
    return request.post(`${PREFIX_URL}/operation/asin361/salesAnalysis/returnReasonAnalysis`, params).then(res => res.data)
}

/**
 * 获取换货原因数据
 * asin-361
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postReplacementReasonAnalysis = params => {
    return request.post(`${PREFIX_URL}/operation/asin361/salesAnalysis/replacementReasonAnalysis`, params).then(res => res.data)
}

/**
 * 获取费用明细
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postFeeDetails = params => {
    return request.post(`${PREFIX_URL}/operation/asin361/feeDetails`, params).then(res => res.data)
}


/**
 * 获取库存分析汇总
 * @param params
 * @returns {Promise<unknown>}
 */
 export function getStorageAnalysisTotal(params) {
    return request.post(`/supply/storageAnalysis/total`, params).then(res => res.data)
  }

/**
 * 获取物流方式下拉
 * @param params
 * @returns {Promise<unknown>}
 */
 export function getTransportSelect(params) {
    return request.get(`/supply/transport/select`, {params}).then(res => res.data);
 }
/**
 * 查询智能补货计算信息
 * @param params
 * @returns {Promise<unknown>}
 */
 export function getStorageAnalysisGetSmart(params) {
    return request.post(`/supply/storageAnalysis/get/smart`, params).then(res => res.data);
  }

/**
 * 更新智能补货计算信息
 * @param params
 * @returns {Promise<unknown>}
 */
 export function storageAnalysisUpdateSmart(params) {
    return request.post(`/supply/storageAnalysis/update/smart`, params).then(res => res.data);
  }

  /**
 * 查询预估list
 * @param params
 * @returns {Promise<unknown>}
 */
 export function storageAnalysisListEstimate(params) {
    return request.post(`/supply/storageAnalysis/list/Estimate`, params).then(res => res.data);
  }

/**
 * 获取库存明细table数据
 * @param params
 * @returns {Promise<unknown>}
 */
 export function storageAnalysisStorageList(params) {
    return request.post(`/supply/storageAnalysis/storage/list`, params).then(res => res.data);
  }

/**
 * 获取单据明细table数据
 * @param params
 * @returns {Promise<unknown>}
 */
 export function storageAnalysisReceiptList(params) {
    return request.post(`/supply/storageAnalysis/receipt/list`, params).then(res => res.data);
  }

/**
 * 获取fba已接收库存table数据
 * @param params
 * @returns {Promise<unknown>}
 */
 export async function storageAnalysisFbaReceived(params) {
    return request.post(`/supply/storageAnalysis/fba/received`, params).then(res => res.data);
  }

/**
 * 获取FBA详情货件table数据
 * @param params
 * @returns {Promise<unknown>}
 */
 export async function storageAnalysisShipmentList(params) {
    return request.post(`/supply/storageAnalysis/shipment/list`, params).then(res => res.data);
  }

/**
 * 添加预估
 * @param params
 * @returns {Promise<unknown>}
 */
 export async function storageAnalysisAddEstimate(params) {
    return request.post(`/supply/storageAnalysis/add/Estimate`, params).then(res => res.data);
  }

/**
 * 删除预估
 * @param params
 * @returns {Promise<unknown>}
 */
 export function storageAnalysisDelEstimate(params) {
    return request.post(`/supply/storageAnalysis/del/Estimate`, params).then(res => res.data);
  }

  /**
   * 查询智能补货信息
   * @param params
   * @returns {Promise<unknown>}
   */
  export function storageAnalysisSmartReplenishment(params) {
    return request.post(`/supply/storageAnalysis/smart/replenishment`, params).then(res => res.data);
  }

export function getKeywordRankingDistribution(params) {
  return request.get(`/ads/asin361/keywordRank/rankingDistribution`, {params}).then(res => res.data);
}

export function getKeywordRankingDynamics(params) {
  return request.get(`/ads/asin361/keywordRank/rankingDynamics`, {params}).then(res => res.data);
}

export function getKeywordRankingPage(params) {
  return request.post(`/ads/asin361/keywordRank/page`, params).then(res => res.data);
}

// --------------------  全店运营分析  --------------------------
/**
 * 获取综合分析-概览/饼图
 * @param params
 * @returns {Promise<unknown>}
 */

export function getOverviewAndPieData(params) {
  return request.get('/operation/storeOperation/comprehensive/overviewAndPie', {params})
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

/**
 * 获取综合分析-折线图
 * @param params
 * @returns {Promise<unknown>}
 */
export function getlineChartData(params) {
    return request.get('/operation/storeOperation/comprehensive/lineChart', {params})
        .then((res) => {
            let resMap = res.data
            resMap.statisticsData || (resMap.statisticsData = [])
            resMap.statisticsData = resMap.statisticsData.map((item) => {
                for (const key in item) {
                    if (item[key] === null) {
                        item[key] = 0
                    }
                }
                return item
            })
            resMap.thenData || (resMap.thenData = [])
            resMap.thenData = resMap.thenData.map((item) => {
                for (const key in item) {
                    if (item[key] === null) {
                        item[key] = 0
                    }
                }
                return item
            })
            return Promise.resolve(resMap);
        });
}

/**
 * 获取盈利分析
 * @param params
 * @returns {Promise<unknown>}
 */

export function getProfitProfileData(params) {
  return request.post('/operation/storeOperation/profitProfile', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}
/**
 * 获取销售分析-指标明细
 * @param params
 * @returns {Promise<unknown>}
 */
export function getIndexDetails(params) {
    return request.post('/operation/storeOperation/sale/indexDetail', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}
/**
 * 获取销售分析-订单站点分布与订单累计分布
 * @param params
 * @returns {Promise<unknown>}
 */
export function getOrderDistributedData(params) {
    return request.get('/operation/storeOperation/sale/orderDistributed', {params})
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

/**
 * 获取review分析数据统计
 * @param params
 * @returns {Promise<unknown>}
 */
export function getReviewAnalyseData(params) {
    return request.post('/crm/storeOperation/reviewAnalyse', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}
/**
 * 获取review分析统计图表
 * @param params
 * @returns {Promise<unknown>}
 */
export function getReviewChartData(params) {
    return request.post('/crm/storeOperation/reviewChart', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}
/**
 * 获取广告分析-店铺汇总统计
 * @param params
 * @returns {Promise<unknown>}
 */

export function getAnalysisMarketData(params) {
    return request.get('/ads/statistics/analysis/market', {params})
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

/**
 * 广告分析-店铺按类型统计
 * @param params
 * @returns {Promise<unknown>}
 */
export function getAnalysisMarketTypeData(params) {
    return request.get('/ads/statistics/analysis/market/type', {params})
        .then((res) => {
            return Promise.resolve(res.data);
        });
}
/**
 * 广告分析-分页查询店铺分析
 * @param params
 * @returns {Promise<unknown>}
 */
export function getStoreAnalyzeAdsInfo(params) {
    return request.post('/ads/statistics/analysis/ads/info', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}
/**
 * 获取费用明细
 * @param params
 * @returns {Promise<unknown>}
 */
export function getFeeDetails(params) {
    return request.post(`/operation/storeOperation/feeDetails`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

/**
 * 获取词云排行榜
 * @param params
 */
export function postWordRanked (params) {
    return request.post(`${PREFIX_URL}/crm/asin361/wordRanked`, params).then((res) => res.data);
}

/**
 * 获取广告词云排行榜
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function postAdWordRanked (params) {
    return request.get(`${PREFIX_URL}/ads/statistics/analysis/asin/wordClouds/get`, {params}).then((res) => res.data);
}

// 通过id获取数据
export function performanceData(type, id) {
    return request.get(`/operation/performance/${type}?id=${id}`).then(res => res.data);
}

/**
 * 查询review词云过滤常用词
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getKeywords (params) {
    return request.post(`${PREFIX_URL}/crm/asin361/filterWord`,  params).then(res => res.data)
}

/**
 * 更新review词云过滤常用词
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function postKeywords (params) {
    return request.post(`${PREFIX_URL}/crm/asin361/updateFilterWord`, params).then(res => res.data)
}

/**
 * 广告词云过滤词获取
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getAdKeywords (params) {
    return request.get(`${PREFIX_URL}/ads/statistics/analysis/asin/wordClouds/getFilters`, { params }).then(res => res.data)
}

/**
 * 广告词云过滤词更新
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function postAdKeywords (params) {
    return request.post(`${PREFIX_URL}/ads/statistics/analysis/asin/wordClouds/cuFilters`, params).then(res => res.data)
}
//---------------------    end   -------------------------------

// -------------------- 店铺绩效  --------------------------
// 店铺绩效列表
export function performance(params) {
    return request.post(`/operation/performance`, params).then(res => res.data);
}
// 店铺绩效详情
export function performanceDetail(marketId, countryCode) {
    return request.get(`/operation/performance/${marketId}/${countryCode}`).then(res => res.data);
}
// 执行job
export function executeSyncJob(params) {
    return request.post(`/operation/performance/executeSyncJob`, params).then(res => res.data);
}
// -------------------- 店铺绩效 end  --------------------------

// 利润统计
export function profitStatisticsPage(params) {
    return request.post(`/operation/profitStatistics/page`, params).then(res => res.data);
}

/**
 * 分页查询任务进度
 * @param params
 * @returns {Promise<unknown>}
 */
export function statsticsProfitTaskPage(params) {
    return request.post('/operation/taskProgressMonitoring/page', params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}

/**
 * 获取所有任务数量
 * @returns {Promise<unknown>}
 */
export function getAllProgressCount() {
    return request.get('/operation/taskProgressMonitoring/getProgressingCount')
        .then((res) => {
            return Promise.resolve(res.data)
        })
}


/**
 * 重算
 * @param params
 * @returns {Promise<unknown>}
 */
export function recalculateFinanceAnalysisReport(params) {
    return request.post(`/operation/profitStatistics/profitRecalculation`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}


// 已接收库存
export function receiptsInventoryPage(params) {
    return request.post(`/supply/receiptsInventory/page`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}

// 库存动作查询
export function receiptsInventoryExport(params) {
    return request.post(`/supply/inventoryEventDetail/page`, params)
    .then((res) => {
        return Promise.resolve(res.data)
    })
}

// 日期范围报告---------------------------------------------------------------
// 列表
export function dateRangePage(params) {
    return request.post(`/finance/dateRangeReportsMainLog/page`, params)
    //     return request.post(`https://mockapi.eolink.com/ztQnBPb887a2f55e56faa03bcee99e1bca808fdc1a3cd91/dateRangeReportsMainLog/page`, params)
        .then((res) => {
            return Promise.resolve(res)
        })
}
// 导入
export function dateRangeImport(params) {
    return request.post(`/finance/dateRangeReportsMainLog/import`, params)
        .then((res) => {
            return Promise.resolve(res)
        })
}
// 日志
export function dateRangeLog(params) {
    return request.post(`/finance/dateRangeReportsLog/list`, params)
    // return request.post(`https://mockapi.eolink.com/ztQnBPb887a2f55e56faa03bcee99e1bca808fdc1a3cd91/dateRangeReportsLog/list`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}
// 重新获取
export function dateRangeRetake(params) {
    return request.post(`/finance/dateRangeReportsMainLog/retake`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}
// 下载
export function dateRangeDownload(params) {
    return request.post(`/finance/dateRangeReportsMainLog/downloadLog`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}
export function dateRangeLogDownload(params) {
    return request.post(`/finance/dateRangeReportsLog/downloadLog`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}

// 业务范围报告---------------------------------------------------------------
// 列表
export function businessPage(params) {
    return request.post(`/operation/businessReportLog/page`, params)
        //     return request.post(`https://mockapi.eolink.com/ztQnBPb887a2f55e56faa03bcee99e1bca808fdc1a3cd91/dateRangeReportsMainLog/page`, params)
        .then((res) => {
            return Promise.resolve(res)
        })
}
// 导入
export function businessImport(params) {
    return request.post(`/operation/businessReportLog/import`, params)
        .then((res) => {
            return Promise.resolve(res)
        })
}
// 日志
export function businessLog(params) {
    return request.post(`/operation/businessReportLogDetail/list`, params)
        // return request.post(`https://mockapi.eolink.com/ztQnBPb887a2f55e56faa03bcee99e1bca808fdc1a3cd91/dateRangeReportsLog/list`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}
// 重新获取
export function businessRetake(params) {
    return request.post(`/operation/businessReportLog/retake`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}
// 下载
export function businessDownload(params) {
    return request.post(`/operation/businessReportLog/downloadLog`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}
export function businessLogDownload(params) {
    return request.post(`/operation/businessReportLogDetail/downloadLog`, params)
        .then((res) => {
            return Promise.resolve(res.data)
        })
}